import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const formatCurrency = (value) => {
  return `$${value.toFixed(2)}`;
};

const formatNumber = (value) => {
  return value.toLocaleString();
};

const formatDate = (dateStr) => {
  // Parse YYYY-MM-DD directly to avoid timezone conversion
  const [year, month, day] = dateStr.split('-');
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${months[parseInt(month, 10) - 1]} ${parseInt(day, 10)}`;
};

function LlmCostChart({ data }) {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis 
          dataKey="date" 
          tickFormatter={formatDate}
        />
        <YAxis 
          tickFormatter={formatCurrency}
        />
        <Tooltip
          content={({ active, payload, label }) => {
            if (active && payload && payload.length) {
              const data = payload[0].payload;
              return (
                <div style={{ 
                  backgroundColor: '#fff',
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '4px'
                }}>
                  <p style={{ margin: '0', fontWeight: 'bold' }}>{formatDate(label)}</p>
                  <p style={{ margin: '5px 0' }}>Prompt Cost: {formatCurrency(data.promptCost)}</p>
                  <p style={{ margin: '5px 0' }}>Candidates Cost: {formatCurrency(data.candidatesCost)}</p>
                  <p style={{ margin: '5px 0', fontWeight: 'bold' }}>Total Cost: {formatCurrency(data.totalCost)}</p>
                  <hr style={{ margin: '5px 0', border: '0.5px solid #eee' }} />
                  <p style={{ margin: '5px 0' }}>Prompt Tokens: {formatNumber(data.promptTokens)}</p>
                  <p style={{ margin: '5px 0' }}>Candidates Tokens: {formatNumber(data.candidatesTokens)}</p>
                  <p style={{ margin: '5px 0', fontWeight: 'bold' }}>Total Tokens: {formatNumber(data.totalTokens)}</p>
                </div>
              );
            }
            return null;
          }}
        />
        <Legend />
        <Bar dataKey="promptCost" stackId="costs" fill="#8884d8" name="Prompt Cost" />
        <Bar dataKey="candidatesCost" stackId="costs" fill="#82ca9d" name="Candidates Cost" />
      </BarChart>
    </ResponsiveContainer>
  );
}

export default LlmCostChart;
